import axiosClient from './axiosClient';

export const registerStudent = (token, formData) => {
  return axiosClient.post(`/student/${token}/register`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const getDriveInfo = (token) => {
  return axiosClient.get(`/student/drive-info/${token}`);
};

export const getAssessmentQuestions = (token) => {
  const studentToken = localStorage.getItem(`studentToken:${token}`) || localStorage.getItem('studentToken');
  const headers = {};
  if (studentToken) {
    headers.Authorization = `Bearer ${studentToken}`;
    headers['x-student-token'] = studentToken;
  }
  return axiosClient.get(`/student/questions/${token}`, { headers });
};

export const validateAssessment = (token) => {
  return axiosClient.get(`/student/${token}`);
};

export const getSessionStatus = (token, email) => {
  const url = `/student/session-status/${token}?email=${encodeURIComponent(email)}`;
  return axiosClient.get(url);
};

export const sessionSave = (data) => {
  // data: { token, sessionToken, questionId, selectedOptionId }
  return axiosClient.post('/student/session/save', withStudentToken(data));
};

export const sessionPosition = (data) => {
  // data: { token, sessionToken, currentQuestionIndex }
  return axiosClient.post('/student/session/position', withStudentToken(data));
};

export const sessionSubmit = (data) => {
  // data: { token, sessionToken }
  return axiosClient.post('/student/session/submit', withStudentToken(data));
};

export const syncSessionIndex = (data) => {
  // data: { token, sessionToken, currentQuestionIndex }
  return axiosClient.post('/student/session/sync-index', withStudentToken(data));
};

export const validatePublished = (token) => {
  const studentToken = localStorage.getItem(`studentToken:${token}`) || localStorage.getItem('studentToken');
  const headers = {};
  if (studentToken) {
    // Put student token in a separate header to avoid being overwritten by adminToken interceptor
    headers['x-student-token'] = studentToken;
    headers.Authorization = `Bearer ${studentToken}`;
  }
  return axiosClient.get(`/assess/${token}`, { headers });
};

const withStudentToken = (data = {}) => {
  const token = data.token;
  const namespaced = token ? localStorage.getItem(`studentToken:${token}`) : null;
  return { ...data, studentToken: namespaced || localStorage.getItem('studentToken') };
};

export const saveAnswer = (data) => {
  // data: { token, questionId, optionId }
  return axiosClient.post('/student/save-answer', withStudentToken(data));
};

export const reportViolation = (data) => {
  const payload = withStudentToken(data);
  const url = `${axiosClient.defaults.baseURL}/student/violation`;
  
  if (navigator.sendBeacon) {
    const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
    navigator.sendBeacon(url, blob);
    return Promise.resolve({ data: { success: true } });
  } else {
    return fetch(url, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json'
      },
      keepalive: true
    }).then(r => r.json());
  }
};

export const submitAssessment = (data) => {
  // data: { token }
  return axiosClient.post('/student/submit', withStudentToken(data));
};

// ---- Coding questions (Judge0 via backend) ----
export const codeRun = (data) => {
  // data: { token, questionId, language, sourceCode, customInput? }
  return axiosClient.post('/student/code/run', withStudentToken(data));
};

export const codeSubmit = (data) => {
  // data: { token, questionId, language, sourceCode }
  return axiosClient.post('/student/code/submit', withStudentToken(data));
};

export const codeSaveDraft = (data) => {
  // data: { token, questionId, language, sourceCode }
  return axiosClient.post('/student/code/draft', withStudentToken(data));
};
